module.exports = __webpack_public_path__ + "images/assets/c3c7698d9ad75560011c8703cdb0ce49.svg";